// Caller-side call route (/calling): ringing, queue wait and in-call (screens 3-5).
// All call behaviour lives in core/VideoState; this file is presentation only.
import { useEffect } from 'react'
import VideoState from '../core/VideoState'
import CallView from './CallView'
import { t } from '../i18n'

const CallScreen = () => {
  useEffect(() => {
    if (!navigator.onLine) alert(t.checkConnection)
  }, [])

  // DON'T ALLOW BACK NAVIGATION WHILE A CALL IS BEING SET UP / IN PROGRESS.
  useEffect(() => {
    window.history.pushState(null, '', null)
    window.onpopstate = function () {
      window.history.go(1)
    }
    return () => {
      window.onpopstate = null
    }
  }, [])

  // DON'T ALLOW PULL-TO-REFRESH ON MOBILE.
  useEffect(() => {
    document.body.style.overscrollBehaviorY = 'contain'
    return () => {
      document.body.style.overscrollBehaviorY = ''
    }
  }, [])

  // WARN BEFORE LEAVING THE PAGE MID-CALL.
  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault()
      e.returnValue = ''
      return ''
    }
    window.addEventListener('beforeunload', handleBeforeUnload)
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [])

  return (
    <VideoState isCallStatus={'OUT'}>
      <CallView />
    </VideoState>
  )
}

export default CallScreen
